// ============================================================
// section-pa-faq.js — FAQ Accordion for ParticleActive
// ============================================================

document.addEventListener('DOMContentLoaded', function () {
   // ===== FAQ ACCORDION =====
  document.querySelectorAll('.pa-faq-item').forEach(function (item) {
    var question = item.querySelector('.pa-faq-question');
    if (!question) return;
    question.addEventListener('click', function () {
      var isActive = item.classList.contains('pa-active');
      var list = item.closest('.pa-faq-list');
      if (list) {
        list.querySelectorAll('.pa-faq-item').forEach(function (i) { i.classList.remove('pa-active'); });
      }
      if (!isActive) item.classList.add('pa-active');
    });
  });
});
